import { useCallback } from "react";
function useInternalEventCallback(platform, elementRef, eventHandler, customEventType, getEventDetail) {
  return useCallback(event => {
    var _elementRef$current;
    if (typeof eventHandler === "function") {
      eventHandler(event);
    }
    (_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.dispatchEvent(new CustomEvent(customEventType, {
      bubbles: true,
      cancelable: false,
      detail: {
        ...getEventDetail(),
        platform
      }
    }));
  }, [eventHandler, elementRef, customEventType, getEventDetail, platform]);
}
function getEventCallbackHook(platform, elementRef, getEventDetail) {
  return function useEventCallback(eventHandler, customEventType) {
    return useInternalEventCallback(platform, elementRef, eventHandler, customEventType, getEventDetail);
  };
}

// Returns an object that has event handlers which are wired up to also
// dispatch the associated custom events.
export default function useEventCallbacks(platform, elementRef, _ref) {
  let {
    onEnded,
    onError,
    onLoadedMetadata,
    onPause,
    onPlay,
    onPlaying,
    onTimeUpdate
  } = _ref;
  let getEventDetail = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : () => {};
  const useEventCallback = getEventCallbackHook(platform, elementRef, getEventDetail);
  return {
    onEnded: useEventCallback(onEnded, "unityended"),
    onError: useEventCallback(onError, "unityerror"),
    onLoadedMetadata: useEventCallback(onLoadedMetadata, "unityloadedmetadata"),
    onPlay: useEventCallback(onPlay, "unityplay"),
    onPlaying: useEventCallback(onPlaying, "unityplaying"),
    onPause: useEventCallback(onPause, "unitypause"),
    onTimeUpdate: useEventCallback(onTimeUpdate, "unitytimeupdate")
  };
}